import BasePostGrid from "@PegasusCore/pegasus-one-post-grid/src/script";

class PostGrid extends BasePostGrid {
    init() {
        super.init();
    }

    getSelectedFilterText(filter){
        const filterResults = this.currentFilters[`filter-t-${filter}`];
        let filtersArray = [];
        if(filterResults){
            filtersArray = filterResults.split(',');
        }

        const escapeHtml = (unsafe) => {
            return unsafe.replaceAll('&', '&amp;').replaceAll('<', '&lt;').replaceAll('>', '&gt;').replaceAll('"', '&quot;').replaceAll("'", '&#039;');
        }

        if(filtersArray.length === 1){
            let sector = filtersArray[0];
            sector =  escapeHtml(sector);
            const text = this.$root.querySelector(`#${sector}`).textContent;
            return text;
        }

        return 'Multiple';
    }

    /**
     * clearFilters
     * 
     * Description: Empty the current filters and refresh the page.
     * 
     * @return void
     */
    clearFilters(taxonomy = null, type = null) {
        if(!taxonomy || !type) {
            this.currentFilters = {};
            window.location.href = window.location.protocol + '//' + window.location.hostname + window.location.pathname;
        } else {
            const filter = this.getPrefixedFilter(taxonomy, type);
            if(this.currentFilters[filter]) {
                delete this.currentFilters[filter];
            }
            this.fetchContent();
        }
            
    }
}

document.addEventListener('alpine:init', () => {
    Alpine.data('postGrid', () => new PostGrid());
});
